import { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useLocation } from 'react-router-dom';
import { useMyContext } from '../../components/provider/MyProvider'

// 버튼 고정 여부 관리 Hook
function useFixedButtonState() {
  const [isFixedButton, setFixedButton] = useState<boolean>(false);
  const location = useLocation();

  useEffect(() => {
    if (isMobile)
      if (
        location.pathname.includes('product') ||
        location.pathname.includes('order') ||
        location.pathname.includes('cart') ||
        location.pathname.includes('myshopping')
      ) {
        setFixedButton(true);
      } else {
        setFixedButton(false);
      }
    else {
      if (location.pathname.includes('myshopping')) {
        setFixedButton(true);
      } else {
        setFixedButton(false);
      }
    }
  }, [location.pathname]);

  return isFixedButton;
}

/**
 * 토스트 팝업
 * 타입1: 메시지
 * 타입2: 메시지 + 버튼(가로100%)
 * @params {string} message - 토스트 팝업 내용
 * @params {string} btnMessage - (선택 인자) 토스트 팝업 버튼 내용
 * @params {any} event - (선택 인자) btnMessage를 눌렀을때 실행될 이벤트
 */

export default function Toast({ message, btnMessage, event }: { message?: string; btnMessage?: string; event?: any }) {
  const {
    isToast,
    setIsToast,
    toastMessage,
    setToastMessage,
    toastBtnMessage,
    setToastBtnMessage,
    toastEvent,
    setToastEvent,
  } = useMyContext();

  const isFixedButton = useFixedButtonState();
  const [timerId, setTimerId] = useState<number | null>(null);

  useEffect(() => {
    // 기존 타이머가 있으면 취소
    if (timerId) {
      clearTimeout(timerId);
    }

    const newTimerId = window.setTimeout(() => {
      setIsToast(false);
      setToastMessage('');
      setToastBtnMessage('');
      setToastEvent(() => {});
    }, 3000);

    setTimerId(newTimerId);

    return () => clearTimeout(newTimerId);
  }, [toastMessage, isToast]);

  if (!isToast) return null;
  else
    return (
      <>
        {toastBtnMessage === '' ? (
          // 타입1
          <div
            style={{
              position: 'fixed',
              left: '50%',
              top: isMobile ? undefined : '0px',
              bottom: isMobile ? (isFixedButton ? '80px' : '20px') : undefined,
              transform: 'translateX(-50%) translateY(100%)',
              backgroundColor: 'rgba(17,17,17,0.92)',
              boxShadow: '0px 4px 10px 0px rgba(0, 0, 0, 0.25)',
              color: 'var(--colWhite)',
              padding: '18px 16px',
              borderRadius: '9px',
              animation: 'toast-slide-up 0.5s ease forwards',
              zIndex: 100000,
              fontSize: 14,
              fontWeight: 500,
              lineHeight: '16px',
              whiteSpace: 'nowrap',
            }}
          >
            {/* {message} */}
            {toastMessage}
            <style>
              {`
            @keyframes toast-slide-up {
              from {
                transform: ${isMobile ? 'translateX(-50%) translateY(100%)' : 'translateX(-50%) translateY(0%)'};
              }
              to {
                transform: ${isMobile ? 'translateX(-50%) translateY(0)' : 'translateX(-50%) translateY(70px)'};
              }
            }
          `}
            </style>
          </div>
        ) : (
          // 타입2
          <div
            style={{
              position: 'fixed',
              top: isMobile ? undefined : '0px',
              bottom: isMobile ? (isFixedButton ? '80px' : '20px') : undefined,
              minWidth: isMobile ? '100%' : '400px',
              display: 'flex',
              justifyContent: 'center',
              animation: 'toast-slide-up 0.5s ease forwards',
              zIndex: 100000,
              left: '50%',
              transform: 'translateX(-50%) translateY(100%)',
            }}
          >
            <div
              style={{
                backgroundColor: 'rgba(17,17,17,0.92)',
                boxShadow: '0px 4px 10px 0px rgba(0, 0, 0, 0.25)',
                color: 'var(--colWhite)',
                borderRadius: '9px',
                fontSize: 14,
                fontWeight: 500,
                lineHeight: '16px',
                display: 'flex',
                justifyContent: 'space-between',
                gap: '10px',
                margin: isMobile ? '0 20px' : '0px',
                width: '100%',
                padding: '18px 16px',
              }}
            >
              <p
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignSelf: 'center',
                  flex: '1',
                  fontSize: '14px',
                  lineHeight: '16px',
                  fontWeight: '500',
                }}
              >
                {/* {message} */}
                {toastMessage}
              </p>
              <p
                onClick={() => {
                  // event();
                  toastEvent();
                }}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignSelf: 'center',
                  cursor: 'pointer',
                  width: '60px',
                  height: '100%',
                  textAlign: 'center',
                  fontSize: '14px',
                  lineHeight: '16px',
                  fontWeight: '500',
                }}
              >
                {/* {btnMessage} */}
                {toastBtnMessage}
              </p>
            </div>

            <style>
              {`
            @keyframes toast-slide-up {
              from {
                transform: ${isMobile ? 'translateX(-50%) translateY(100%)' : 'translateX(-50%) translateY(0%)'};
              }
              to {
                transform: ${isMobile ? 'translateX(-50%) translateY(0)' : 'translateX(-50%) translateY(70px)'};
              }
            }
          `}
            </style>
          </div>
        )}
      </>
    );
}
